import axios from 'axios';
import { sortBy } from 'lodash';

import { ENV, VALID } from 'common/const';
import { getBaseUrl, log } from 'common/utils';
import { getAssessment } from 'data/utils';

import mock from './getAssessmentQuestions.mock';

const baseUrl = getBaseUrl(2);

/**
 * Get assessment data based on a given event and assessment question type
 * @param ooId - id for event
 * @param [questionType] - 0 = ALL 1 = Booth setup 2 = Booth work
 * @returns object with the event data
 */
const getAssessmentQuestions = async ({
  ooId,
  questionType = 0,
  boothType = 'blank',
  boothLocation = 'blank',
}) => {
  await VALID.checkAll(
    ['ooId', ooId, VALID.OO_SUMMARY_ID],
    ['questionType', questionType, VALID.NUM],
  );

  try {
    const { data } = ENV.IS_MOCK
      ? mock()
      : await axios.get(
          `${baseUrl}events/assessment_question_list/${ooId}/${questionType}/${boothType}/${boothLocation}`,
      );

    const mapped = data.assessmentData
        .map((item) => ({ ...item, sortOrder: Number(item.sortOrder) }))
        .map(getAssessment);

      const list = sortBy(mapped, 'sortOrder');   

      //console.log(list);

    return { list }; 

    //return {
    //  list: sortBy(
    //    data.assessmentData
    //      // .filter(({ isVisible }) => isVisible)  the back end currently does not set isVisible
    //        //.map((item) => ({ ...item, }))
    //        .map((item) => ({ ...item, sortOrder: Number(item.sortOrder) }))
    //        .map(getAssessment), (x) => x.sortOrder
    //    ['sortOrder'],
    //  ),
      //};

  } catch (error) {
    log('getAssessmentQuestions', {
      data: { ooId, questionType },
      error,
      throw: true,
      type: 'request',
    });
  }
};

export default getAssessmentQuestions;
